import React, { useEffect, useState, useTransition } from "react";
import SideMenu from "../Pages/SideMenu";
import Header from "../Pages/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Footer from "../Pages/Footer";
import Logout from "../Pages/Logout";
import { Button } from "react-bootstrap";
import { CustomTable } from "../CustomTable";
import { EquipmentLocationMasterAdd, EquipmentLocationMasterGet, } from "../Utilities/URLCONSTANTS";
import axios from "axios";
import { CustomModal } from "../CustomModal";
import { GetApiHeaders } from "../Utilities/NetworkUtilities";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import Add_Icon from "../images/Add_Icon.svg";
import { formatRoleName, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";

export const EquipmentLocationMaster = () => {
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [name, setName] = useState()
    const [status, setStatus] = useState()
    const [id, setId] = useState()
    const [saveEdit, setSaveEdit] = useState()
    const [responseMsg, setResponseMsg] = useState()
    const [msgPopup, setMsgPopup] = useState(false)
    const [error, setError] = useState('')
    const [statusError, setStatusError] = useState('')
    const [loader, setLoader] = useState(false)
    const { t } = useTranslation()

    const getData = async () => {
        const URL = EquipmentLocationMasterGet;
        try {
            setLoader(true)
            const response = await axios.get(URL)
            setData(response.data.response)
            setLoader(false)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const headersData = [
        {
            field: "location",
            header: "Equipment Location",
        },
        {
            field: "createdBy.firstName",
            header: "Created By",
        },
        {
            field: "status",
            header: "Status",
        },
    ];

    const onEditClicked = (data) => {
        console.log(data)
        setSaveEdit('Update')
        setId(data.id)
        setShowModal(true)
        setName(data.location)
        setStatus(data.status)
        setStatusError('')
        setError('')
    }

    const handleModalOpen = () => {
        setSaveEdit('Submit')
        setShowModal(true)
        setName('')
        setStatus('')
        setStatusError('')
        setError('')
    }
    const handleCancel_new = () => {
        setShowModal(false)
    }

    const handleName = (e) => {
        const input = e.target.value;
        // const alphabeticInput = input.replace(/[^a-zA-Z ]/g, "");
        const formattedInput = formatRoleName(input);
        setName(formattedInput)
        if (input) {
            setError('')
        }
    }


    const handleStatus = (e) => {
        const statusInput = e.target.value
        setStatus(statusInput)
        if (statusInput) {
            setStatusError('')
        }
    }

    const handleSubmitData = async () => {
        if (!status) {
            setStatusError("Select Status")
        }

        if (!name) {
            setError('Enter Equipment Location')
        }
        const apiUrl = EquipmentLocationMasterAdd;
        const reqData = {
            id: saveEdit === "Submit" ? 0 : id,
            locationName: name,
            status: status
        }
        const headers = await GetApiHeaders()
        try {
            if (name !== '' && status !== '') {
                setLoader(true)
                const response = await axios.post(apiUrl, reqData, { headers })
                if (response.data.statusCode == 200 || response.data.status == 500) {
                    setShowModal(false)
                    setMsgPopup(true)
                    setResponseMsg(response.data.message);
                    setLoader(false)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleOk = () => {
        setMsgPopup(false)
        getData()
    }

    return (
        <body id="page-top">
            <div id="wrapper">
                <SideMenu />
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header />
                        <div>
                            <div className="container-fluid">
                                <div className="card border-0">
                                    <div className="card-body pt-0 pl-1">
                                        <h5 className="Roles_text">{t('Master')}</h5>
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-0 Sub_role_text"> {t('Equipment_Location_Master')}</h6>
                                            </div>
                                            <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title={t('Add_Equipment_Location_Master')}  >
                                                <Button variant="primary" className="buttons" onClick={handleModalOpen}  >
                                                    <img
                                                        src={Add_Icon}
                                                        alt="Add"
                                                        className="addicon"
                                                    />
                                                    {t('Add')}
                                                </Button>
                                            </span>
                                        </div>
                                        <div className="mcrc_hrline"></div>
                                        <CustomTable
                                            headers={headersData}
                                            data={data}
                                            showAction={true}
                                            showButtons={true}
                                            ActionEdit={true}
                                            FileName={'Equipment_Location'}
                                            onEditClicked={onEditClicked}
                                            ActionName={"Action"}
                                            loader={loader}
                                        />

                                        <CustomModal
                                            showModal={showModal}
                                            handleCancel_new={handleCancel_new}
                                            tittle={t('Equipment_location')}
                                            buttonText={saveEdit}
                                            handleSubmitData={handleSubmitData}
                                            childrens={
                                                <div>
                                                    <div className='row'>
                                                        <div className='col-md-6 col-12'>
                                                            <label for="exampleInputPassword1" className="form-label text-sm font-weight-600 mt-1">
                                                                {t('Equipment_location')}   <span style={{ color: "red" }}>*</span>
                                                            </label>
                                                            <div className="input-group input-group w-100">
                                                                <input type="text" className="form-control p-2 " maxLength={30} placeholder='Enter Location Name' value={name} onChange={handleName} />
                                                            </div>
                                                            <span style={{ color: "red" }}> {error}</span>
                                                        </div>

                                                        <div className="col-md-6 col-12">
                                                            <label
                                                                htmlFor="statusDropdown"
                                                                className="form-label text-sm font-weight-600 mt-1"
                                                            >
                                                                {t("Status")} <span style={{ color: "red" }}>*</span>
                                                            </label>

                                                            <Select
                                                                inputId="statusDropdown"
                                                                styles={modalCustomStyles}
                                                                placeholder={t("select_Status")}
                                                                isClearable
                                                                value={
                                                                    [
                                                                        { value: "Active", label: t("Active") },
                                                                        { value: "InActive", label: t("In_Active") },
                                                                    ].find((option) => option.value === status) || null
                                                                }
                                                                options={[
                                                                    { value: "Active", label: t("Active") },
                                                                    { value: "InActive", label: t("In_Active") },
                                                                ]}
                                                                onChange={(selectedOption) =>
                                                                    handleStatus({
                                                                        target: {
                                                                            value: selectedOption ? selectedOption.value : "",
                                                                        },
                                                                    })
                                                                }
                                                            />

                                                            <span style={{ color: "red" }}>
                                                                {statusError}
                                                            </span>
                                                        </div>
                                                    </div>

                                                </div>
                                            }
                                        />
                                        <CustomModal
                                            showModal={msgPopup}
                                            msgPopup={msgPopup}
                                            handleOk={handleOk}
                                            handleCancel_new={handleCancel_new}
                                            tittle={t('Equipment_location')}
                                            childrens={<div className="p-4 d-flex justify-content-center" style={{ fontSize: "18px", color: "#4A7729", fontWeight: 500 }}>{responseMsg}</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
            <a className="scroll-to-top rounded" href="#page-top">
                <i className="fas fa-angle-up"></i>
            </a>
            <Logout />
        </body>
    )
}